// import AnnualReturn from "@/src/modules/statutory-compliance/annual-return";
// import StatutoryBlock from "@/src/modules/statutory-compliance/statutoryBlock";
import AnnualReturn from "@/src/modules/governance/uploads/annual-return";
import StatutoryBlock from "@/src/modules/governance/uploads/statutoryBlock";
import DashboardLayout from "@/src/components/layout";
import { pressReleaseApiService } from "@/src/lib/api-services/pressReleaseApiServices";
import { useMemo } from "react";

StatutoryCompliance.getLayout = (page) => (
    <DashboardLayout>{page}</DashboardLayout>
);

export default function StatutoryCompliance({ data }) {
    const uploads = useMemo(() => {
        return Object.values(data.data).map((item) => ({
            documentTypeName: item.documentTypeName,
            uploads: item.uploads,
        }));
    }, [data]);

    return (
        <div className="max-w-6xl mx-auto md:py-16 py-4 px-4">
            <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-black text-center md:mb-10 mb-6">
                Statutory Compliance
            </h1>

            <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 mt-8">
                {/* Left Column (60%) */}
                <div className="lg:col-span-3">
                    {uploads.map((item) => (
                        <AnnualReturn
                            key={item.documentTypeName}
                            title={item.documentTypeName}
                            content={item.uploads}
                        />
                    ))}

                    <p className="text-sm text-gray-500 text-center md:py-5 py-2">
                        Older uploads are archived.
                    </p>
                </div>

                {/* Right Column (40%) */}
                <div className="lg:col-span-2">
                    <div className="rounded-lg shadow bg-primary/5">
                        <h2 className="md:text-xl text-lg font-bold mb-2 text-black md:px-5 px-2 md:pt-6 pt-2">
                            House Of Diagnostic Private Limited
                        </h2>

                        <ul className="list-none list-inside text-gray-600">
                            <StatutoryBlock
                                title="Corporate Office"
                                value="Upper Ground Floor, World Trade Tower, Smartworks, Sector 16 Noida, Uttar Pradesh 201301"
                            />
                            <StatutoryBlock
                                title="Contact Number"
                                value="9089 089 089"
                            />
                            <StatutoryBlock
                                title="Email ID"
                                value="info@hod.team"
                            />

                            <StatutoryBlock title="Website" value="hod.care" />
                        </ul>
                    </div>
                </div>
                {/* <div className="lg:col-span-3"></div> */}
            </div>
        </div>
    );
}

export async function getServerSideProps() {
    const data = await pressReleaseApiService.uploads();
    return {
        props: {
            data: {
                ...data,
                seoTitle: "HOD | House Of Diagnostics | Statutory Compliance",
                seoDescription:
                    "HOD | House Of Diagnostics | Statutory Compliance",
                routerPath: "governance/uploads",
            },
        },
    };
}
